import {
  getNameDescriptionTableColumn,
  getProjectTableColumn,
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import { fetchAiRoutingNameMap } from '@Ai/utils/aiRoutingNames'
import { getAiRoutingDetailField, openAiRoutingSidepage } from '@Ai/utils/aiproxyRoutingLinkColumns'

export default {
  data () {
    return {
      aiRoutingNameMap: {},
    }
  },
  watch: {
    'list.data': {
      handler () {
        this.loadMcpAiRoutingNames()
      },
      deep: true,
    },
  },
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
      }),
      getAiRoutingDetailField(this, {
        emptyText: this.$t('ai.mcp.update_routing_required'),
        onEmptyClick: row => this.openMcpConfigDialog(row),
      }),
      {
        field: 'llm_driver',
        title: this.$t('ai.mcp.api_standard'),
        formatter: ({ row }) => {
          if (row.llm_driver === 'ollama') {
            return 'Ollama'
          } else if (row.llm_driver === 'openai') {
            return 'OpenAI'
          }
          return '-'
        },
      },
      {
        field: 'model',
        title: this.$t('ai.mcp.model'),
        formatter: ({ row }) => {
          return row.model || '-'
        },
      },
      getCopyWithContentTableColumn({
        field: 'llm_url',
        title: this.$t('ai.mcp.llm_url'),
      }),
      {
        field: 'default_agent',
        title: this.$t('ai.mcp.default_agent'),
        formatter: ({ row }) => {
          return row.default_agent ? this.$t('common.true') : this.$t('common.false')
        },
        slots: {
          default: ({ row }) => {
            return row.default_agent ? [<status specifyStatus={{ class: 'status-success', text: this.$t('common.true') }} />] : [<status specifyStatus={{ class: 'status-info', text: this.$t('common.false') }} />]
          },
        },
      },
      getProjectTableColumn(),
    ]
  },
  methods: {
    async loadMcpAiRoutingNames () {
      const rows = Object.values(this.list?.data || {}).map(item => item.data || item)
      const ids = rows.map(row => row.aiproxy_routing_id).filter(Boolean)
      if (!ids.length) return
      const map = await fetchAiRoutingNameMap(ids, { vm: this })
      this.aiRoutingNameMap = { ...this.aiRoutingNameMap, ...map }
    },
    handleOpenAiRoutingSidepage (routingId) {
      openAiRoutingSidepage(this, routingId)
    },
    openMcpConfigDialog (row) {
      if (!row) return
      this.createDialog('McpConfigDialog', {
        type: 'edit',
        data: [row],
        columns: this.columns,
        onManager: this.onManager,
      })
    },
  },
}
